import React from "react";

const UnfoldIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.8335 12.9999L10.0002 17.1666L14.1668 12.9999M5.8335 7.99992L10.0002 3.83325L14.1668 7.99992" stroke="#2D2C44" strokeOpacity="0.7" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>);

export default UnfoldIcon;
